export function isUGSActive(birthDate, ugsMaxAgeInclusive) {
    if (!birthDate || ugsMaxAgeInclusive == null) {
        return false;
    }

    // Reference date: the first day of the current solar year. UGS membership is
    // allowed until the end of the calendar year in which the person turns
    // ugsMaxAgeInclusive, so eligibility is fixed for the whole year.
    const reference = new Date(new Date().getFullYear(), 0, 1);
    const maxUGSBirthDate = new Date(reference);
    maxUGSBirthDate.setFullYear(reference.getFullYear() - ugsMaxAgeInclusive);

    return maxUGSBirthDate <= new Date(birthDate);
}
